export default function CreditsIcons() {
    return <>
        <div style={{ display: 'inline' }}>
            <img style={{ borderRadius: 10, height: 80, width: 80 }} src="/img/credits.png" />
        </div>
    </>
}